import SocketIO from "socket.io-client";

class SocketUtil {
    socket = null;
    init() {
        const socketUrl = "https://prod.salonaz.com";
        this.socket = SocketIO(socketUrl, {transports: ['websocket', 'polling', 'flashsocket']});
        this.socket.on("connect", function() {
            console.log("Socket connected!!!!");
        });
    }
}

export default new SocketUtil();
